module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-5.575944a4.mp3";